import React from 'react'
import SubsLayout from '../../layout/SubsLayout'
import TokenManagement from '../../components/Subscription/TokenManagement'

const TokenManagementPage = () => {
  return (
    <SubsLayout>
        <TokenManagement />
    </SubsLayout>
  )
}

export default TokenManagementPage